import e from "./WithBreadcrumb.vue.script.js";
//#region src/schema/components/WithBreadcrumb.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=WithBreadcrumb.vue.js.map